if (!customElements.get("collections-filtering")) {
  // Helper functions for custom dropdowns
  window.FilterHelpers = {
    initCustomDropdown: function (select) {
      if (select.closest('.custom-select-wrapper')) return; // Already initialized

      select.classList.add('hidden-select');

      const wrapper = document.createElement('div');
      wrapper.className = 'custom-select-wrapper';
      select.parentNode.insertBefore(wrapper, select);
      wrapper.appendChild(select);

      const customSelect = document.createElement('div');
      customSelect.className = 'custom-select';
      wrapper.appendChild(customSelect);

      const trigger = document.createElement('div');
      trigger.className = 'custom-select-trigger';
      trigger.textContent = select.options[select.selectedIndex]?.text || select.getAttribute('placeholder') || 'Select...';
      if (select.disabled) {
        wrapper.classList.add('disabled');
        trigger.classList.add('disabled');
      }
      customSelect.appendChild(trigger);

      const optionsWrapper = document.createElement('div');
      optionsWrapper.className = 'custom-select-options';
      customSelect.appendChild(optionsWrapper);

      // Search Input
      const searchContainer = document.createElement('div');
      searchContainer.className = 'custom-select-search';
      const searchInput = document.createElement('input');
      searchInput.type = 'text';
      searchInput.placeholder = 'Search...';
      searchContainer.appendChild(searchInput);
      optionsWrapper.appendChild(searchContainer);

      // Options Container
      const optionsList = document.createElement('div');
      optionsList.className = 'options-list';
      optionsWrapper.appendChild(optionsList);

      // Populate Options
      this.populateOptions(select, optionsList, trigger, customSelect);

      // Search Functionality
      searchInput.addEventListener('input', (e) => {
        const term = e.target.value.toLowerCase();
        optionsList.querySelectorAll('.custom-option').forEach(option => {
          const text = option.textContent.toLowerCase();
          option.style.display = text.includes(term) ? 'block' : 'none';
        });
      });

      // Event Listeners
      trigger.addEventListener('click', () => {
        if (wrapper.classList.contains('disabled')) return;

        // Close other dropdowns
        document.querySelectorAll('.custom-select').forEach(el => {
          if (el !== customSelect) el.classList.remove('open');
        });

        customSelect.classList.toggle('open');
        if (customSelect.classList.contains('open')) {
          searchInput.value = '';
          searchInput.focus();
          // Reset search
          optionsList.querySelectorAll('.custom-option').forEach(option => {
            option.style.display = 'block';
          });
        }
      });

      // Close when clicking outside
      document.addEventListener('click', (e) => {
        if (!wrapper.contains(e.target)) {
          customSelect.classList.remove('open');
        }
      });
    },

    populateOptions: function (select, optionsList, trigger, customSelect) {
      optionsList.innerHTML = '';
      Array.from(select.options).forEach(option => {
        if (option.disabled && option.value === "") return; // Skip placeholder if desired, or handle differently

        const customOption = document.createElement('div');
        customOption.className = 'custom-option';
        customOption.dataset.value = option.value;
        customOption.textContent = option.text;

        if (option.selected) {
          customOption.classList.add('selected');
        }

        customOption.addEventListener('click', () => {
          select.value = option.value;
          // Trigger change event on original select
          select.dispatchEvent(new Event('change'));

          trigger.textContent = option.text;
          customSelect.classList.remove('open');

          optionsList.querySelectorAll('.custom-option').forEach(opt => opt.classList.remove('selected'));
          customOption.classList.add('selected');
        });

        optionsList.appendChild(customOption);
      });
    },

    refreshCustomDropdown: function (select) {
      const wrapper = select.closest('.custom-select-wrapper');
      if (!wrapper) return;

      const trigger = wrapper.querySelector('.custom-select-trigger');
      const optionsList = wrapper.querySelector('.options-list');
      const customSelect = wrapper.querySelector('.custom-select');

      // Update Trigger Text
      const selectedOption = select.options[select.selectedIndex];
      trigger.textContent = selectedOption ? selectedOption.text : (select.getAttribute('placeholder') || 'Select...');

      // Update Disabled State
      if (select.disabled) {
        wrapper.classList.add('disabled');
        trigger.classList.add('disabled');
      } else {
        wrapper.classList.remove('disabled');
        trigger.classList.remove('disabled');
      }

      // Re-populate options
      this.populateOptions(select, optionsList, trigger, customSelect);
    }
  };

  class CollectionsFiltering extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector("form");
      this.button = this.querySelector('button[type="submit"]');
      this.select = this.querySelector("select.dropdown-collection");
      this.input = this.querySelector("input.input-collection");
      this.selects = this.querySelectorAll("select.dropdown-filter");

      this.setupEventListeners();

      // Initialize custom dropdowns
      this.initCustomDropdowns();

      // There's no collection dropdown so we either need to populate
      // the filters of the entire store or the single collection chosen
      // (if only one collection has been chosen).
      if (!this.select) {
        this.populateCollectionFilters(true);
      }
    }

    setupEventListeners() {
      this.form.addEventListener("submit", (event) => {
        event.preventDefault();
        window.location = this.form.getAttribute("action");
      });
      this.select?.addEventListener("change", this.onCollectionChange.bind(this));
      this.selects.forEach((event) => {
        event.addEventListener("change", this.onFilterChange.bind(this));
      });

      // Close dropdowns when clicking outside
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.custom-select-wrapper')) {
          this.querySelectorAll('.custom-select').forEach(wrapper => {
            wrapper.classList.remove('open');
          });
        }
      });
    }

    initCustomDropdowns() {
      // Add custom dropdown for main collection select if it exists
      if (this.select) {
        this.initCustomDropdown(this.select);
      }

      // Add custom dropdowns for all filter selects
      this.selects.forEach(select => {
        this.initCustomDropdown(select);
      });
    }

    initCustomDropdown(select) {
      if (window.FilterHelpers) {
        window.FilterHelpers.initCustomDropdown(select);
      }
    }

    syncCustomDropdown(select) {
      if (window.FilterHelpers) {
        window.FilterHelpers.refreshCustomDropdown(select);
      }
    }

    constructURL() {
      const collectionUrl =
        this.select?.value ?? this.input?.value ?? window.routes.all_products_url;
      const url = new URL(collectionUrl, window.requestShopUrl);

      this.querySelectorAll("select.dropdown-filter:enabled").forEach((select) => {
        if (select.value === "") {
          return;
        }

        Array.from(select.selectedOptions).forEach((option) => {
          url.searchParams.set(option.dataset.paramName, option.value);
        });
      });

      return url.toString();
    }

    setFormUrl(url, background) {
      this.form.setAttribute("action", url);

      // This operation happens on the background
      // where the user should not be notified of loading with spinners
      // etc.
      if (!background) {
        this.button.disabled = false;
      }
    }

    selectRemoveOptions(select) {
      const options = select.querySelectorAll("option:not(.default)");

      options.forEach((option) => {
        select.removeChild(option);
      });

      select.querySelector("option").selected = true;
    }

    onFilterChange(event) {
      const selectedIndex = event.target.dataset.index;

      // Update current dropdown UI
      this.syncCustomDropdown(event.target);

      this.selects.forEach((select) => {
        if (Number(select.dataset.index) <= Number(selectedIndex)) {
          return;
        }

        this.selectRemoveOptions(select);
        select.disabled = true;
        select.closest(".form-group").classList.add("disabled");
        this.syncCustomDropdown(select); // Sync disabled state
      });

      this.setFormUrl(this.constructURL());

      const url = new URL(this.constructURL());
      url.searchParams.set("view", "do_not_use");
      this.toggleLoading();

      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }

          return response.text();
        })
        .then((text) => {
          this.toggleLoading();
          const resultsMarkup = new DOMParser().parseFromString(text, "text/html");

          this.selects.forEach((select) => {
            if (Number(select.dataset.index) <= Number(selectedIndex)) {
              return;
            }

            const options = resultsMarkup.querySelectorAll(
              `select[data-label="${select.dataset.label}"] option`,
            );
            if (options.length > 0) {
              const availableOptions = Array.from(options).filter(
                (option) => Number(option.dataset.count) > 0,
              );
              select.append(...availableOptions);
              select.querySelector("option.default").selected = true;
            }

            if (Number(select.dataset.index) === Number(selectedIndex) + 1) {
              select.disabled = false;
              select.closest(".form-group").classList.remove("disabled");
            }

            // Sync the custom dropdown after updating options
            this.syncCustomDropdown(select);
          });
        })
        .catch((error) => {
          throw error;
        });
    }

    populateCollectionFilters(background = false) {
      this.setFormUrl(this.constructURL(), background);

      const url = new URL(this.constructURL());
      url.searchParams.set("view", "do_not_use");

      // When we initially populate the filters we don't want
      // to show a loading spinner.
      if (!background) {
        this.toggleLoading();
      }

      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }

          return response.text();
        })
        .then((text) => {
          if (!background) {
            this.toggleLoading();
          }

          const resultsMarkup = new DOMParser().parseFromString(text, "text/html");

          this.selects.forEach((select) => {
            const options = resultsMarkup.querySelectorAll(
              `select[data-label="${select.dataset.label}"] option`,
            );
            if (options.length > 0) {
              select.append(...options);
              select.querySelector("option.default").selected = true;
            }

            if (Number(select.dataset.index) === 1) {
              select.disabled = false;
              select.closest(".form-group").classList.remove("disabled");
            }

            // Sync after populating
            this.syncCustomDropdown(select);
          });
        })
        .catch((error) => {
          throw error;
        });
    }

    onCollectionChange(event) {
      // Sync the collection dropdown itself if needed
      if (event && event.target) {
        this.syncCustomDropdown(event.target);
      }

      this.selects.forEach((select) => {
        this.selectRemoveOptions(select);
        select.disabled = true;
        select.closest(".form-group").classList.add("disabled");
        this.syncCustomDropdown(select);
      });

      this.populateCollectionFilters();
    }

    toggleLoading() {
      this.classList.toggle("is-loading");
      this.button.classList.toggle("loading");
    }
  }

  customElements.define("collections-filtering", CollectionsFiltering);
}
